export default {
    methods: {
        loadRedHelper() {
            const script = document.createElement('script')
      
            script.type = 'text/javascript'
            script.id= "rhlpscrtg" 
            script.type="text/javascript"
            script.charset="utf-8"
            script.async="async"
            script.src = 'https://web.redhelper.ru/service/main.js?c=bimlib'
            
            document.body.appendChild(script)
        }
    }
}